import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Build an absolute URL for an asset.
 * - Absolute http(s) URLs pass through unchanged.
 * - Relative paths (e.g. "/api/files/...") are prefixed with REACT_APP_BACKEND_URL.
 * - Falsy values return null so callers can fall back.
 */
export function assetSrc(url) {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return `${BACKEND_URL}/${url}`;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token if available (fallback to cookie auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
